export const handleDownload = (label, shipmentName) => {
    if (!label) {
        return;
    }
    if (shipmentName === 'EC') {
        // Handle PDF (Base64)
        const link = document.createElement("a");
        const byteCharacters = atob(label);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "application/pdf" });

        link.href = URL.createObjectURL(blob);
        link.download = "label.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } else {
        const link = document.createElement('a');
        link.href = label;
        link.download = 'label.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};